<template>
  <SettingsPageLayout>
    <DetailForm
      title="Telco"
      :description="`Telecommunications`"
      action="Save"
      :hidecancel="true"
      @handleAction="updateTeam"
      v-if="loaded"
    >
      <ToggleInput
        label="Bulk Messaging Enabled"
        description="Allows a Customer to send bulk text messages to their team. Please ensure that the Customer knows they can only bulk message their team and they are not to use the functionality to potentially bulk message Candidates that haven't opted in."
        :modelValue="team.bulkMessagingEnabled"
        @update:modelValue="team.bulkMessagingEnabled = $event"
      />
    </DetailForm>
    <DetailForm
      class="mt-6"
      title="10DLC Registration"
      description="10DLC numbers are local long-code numbers that are approved by mobile network operators for A2P SMS messaging. This approval comes about by registering the local long-code number with a verified 10DLC brand and an approved 10DLC campaign."
      :hidecancel="true"
      action="Save"
      @handleAction="updateRegistration"
      v-if="loaded"
    >
      <div class="grid grid-cols-2 gap-x-2 gap-y-4">
        <TextInput
          class="col-span-1"
          label="Legal Contact Name"
          placeholder="Chris Giannos"
          :modelValue="team.legalContactName"
          @update:modelValue="value => (team.legalContactName = value)"
        />
        <TextInput
          class="col-span-1"
          label="Legal Contact Title"
          placeholder="CEO"
          :modelValue="team.legalContactTitle"
          @update:modelValue="value => (team.legalContactTitle = value)"
        />
      </div>
      <div class="grid grid-cols-2 gap-x-2 gap-y-4">
        <TextInput
          class="col-span-1"
          label="Legal Contact Email"
          placeholder="support@humaniz.io"
          :modelValue="team.legalContactEmail"
          @update:modelValue="value => (team.legalContactEmail = value)"
        />
        <PhoneInput
          class="col-span-1"
          label="Legal Contact Phone"
          placeholder="+1 (281) 330 8004"
          :modelValue="team.legalContactPhone"
          @update:modelValue="team.legalContactPhone = $event"
        />
        <TextInput
          class="col-span-2"
          label="Legal Company Name"
          placeholder="Humaniz, LLC"
          :modelValue="team.legalCompanyName"
          @update:modelValue="value => (team.legalCompanyName = value)"
        />
        <TextInput
          class="col-span-1"
          label="Website"
          placeholder="www.humaniz.io"
          :modelValue="team.website"
          @update:modelValue="value => (team.website = value)"
        />
        <TextInput
          class="col-span-1"
          label="EIN Number"
          placeholder="12-3456789"
          :modelValue="team.einNumber"
          @update:modelValue="value => (team.einNumber = value)"
        />
      </div>

      <div class="border-t border-gray-200 pt-5 grid grid-cols-2 gap-x-2 gap-y-4">
        <TextInput
          class="col-span-2"
          label="Street Address"
          placeholder="2942 Century Pl"
          :modelValue="team.legalStreetAddress"
          @update:modelValue="value => (team.legalStreetAddress = value)"
        />
        <TextInput
          class="col-span-1"
          label="City"
          placeholder="Costa Mesa"
          :modelValue="team.legalCity"
          @update:modelValue="value => (team.legalCity = value)"
        />
        <TextInput
          class="col-span-1"
          label="State"
          placeholder="CA"
          :modelValue="team.legalState"
          @update:modelValue="value => (team.legalState = value)"
        />
        <TextInput
          class="col-span-1"
          label="Country"
          placeholder="United States"
          :modelValue="team.legalCountry"
          @update:modelValue="value => (team.legalCountry = value)"
        />
        <TextInput
          class="col-span-1"
          label="Zip/Postal Code"
          placeholder="92626"
          :modelValue="team.legalPostalCode"
          @update:modelValue="value => (team.legalPostalCode = value)"
        />
      </div>
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  data() {
    return {
      team: {
        id: '',
        legalContactName: '',
        legalContactTitle: '',
        legalContactEmail: '',
        legalContactPhone: '',
        legalCompanyName: '',
        website: '',
        einNumber: '',
        legalStreetAddress: '',
        legalCity: '',
        legalState: '',
        legalCountry: '',
        legalPostalCode: '',
        plivoRegistrationStatus: '',
        bulkMessagingEnabled: false,
      },
      smsConfiguration: {
        provider: '',
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/teams/1`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.team.id = data.record.id;
          self.team.legalContactName = data.record.legal_contact_name;
          self.team.legalContactTitle = data.record.legal_contact_title;
          self.team.legalContactEmail = data.record.legal_contact_email;
          self.team.legalContactPhone = data.record.legal_contact_phone_number;
          self.team.legalCompanyName = data.record.legal_company_name;
          self.team.website = data.record.website;
          self.team.einNumber = data.record.ein_number;
          self.team.legalStreetAddress = data.record.legal_street;
          self.team.legalCity = data.record.legal_city;
          self.team.legalState = data.record.legal_state;
          self.team.legalCountry = data.record.legal_country;
          self.team.legalPostalCode = data.record.legal_postal_code;
          self.team.bulkMessagingEnabled = data.record.bulk_messaging_enabled;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/teams/${self.team.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          bulk_messaging_enabled: self.team.bulkMessagingEnabled,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Plivo integration updated',
              alertDescription:
                'Your Plivo settings were successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Plivo integration update error',
              alertDescription: data.message,
            });
          }
        });
    },
    updateRegistration() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/teams/${self.team.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          legal_contact_name: self.team.legalContactName,
          legal_contact_title: self.team.legalContactTitle,
          legal_contact_email: self.team.legalContactEmail,
          legal_contact_phone_number: self.team.legalContactPhone,
          legal_company_name: self.team.legalCompanyName,
          website: self.team.website,
          ein_number: self.team.einNumber,
          legal_street: self.team.legalStreetAddress,
          legal_city: self.team.legalCity,
          legal_state: self.team.legalState,
          legal_country: self.team.legalCountry,
          legal_postal_code: self.team.legalPostalCode,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Plivo integration updated',
              alertDescription:
                'Your Plivo settings were successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Plivo integration update error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
